import { GetDraftProviderOptionsResponseType } from "api/response/draftRequest.response";

import { ProviderOption } from "@RequestFormV2/sections/Provider/types";

export function mapProviderOptions(
  invitedProviders: GetDraftProviderOptionsResponseType["invited_providers"] = [],
): ProviderOption[] {
  return invitedProviders.map((item) => ({
    ...item,
    parcel_accounts: (item.parcel_accounts ?? []).map((account) => ({
      ...account,
      label: account.account_name,
      value: String(account.id),
    })),
  }));
}
